import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { EERIE, GREAT_WHITE, OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import { getInboxChannelsTableUrl } from 'conversations-external-deep-links/urls';
import { clickedInboxSettings } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { trackEventBeforeUnload } from '../../usage-tracking/clients/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FooterWrapper = styled.div.withConfig({
  displayName: "InboxSettingsFooterSection__FooterWrapper",
  componentId: "zup840-0"
})(["padding-top:12px;padding-bottom:12px;padding-left:16px;border-top:1px solid ", ";color:", ";display:inline-flex;"], GREAT_WHITE, EERIE);
const LinkWrapper = styled.span.withConfig({
  displayName: "InboxSettingsFooterSection__LinkWrapper",
  componentId: "zup840-1"
})(["color:", ";font-weight:400;"], OBSIDIAN);
const InboxSettingsFooterSection = () => {
  const inboxId = useSelector(getCurrentInboxId);
  return /*#__PURE__*/_jsxs(FooterWrapper, {
    className: "inbox-sidebar-frame-footer",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      className: "m-left-1",
      name: "settings",
      size: 16
    }), /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "inbox-sidebar-settings-button",
      use: "link",
      className: "m-left-2",
      href: getInboxChannelsTableUrl({
        inboxId
      }),
      onClick: () => trackEventBeforeUnload(clickedInboxSettings),
      children: /*#__PURE__*/_jsx(LinkWrapper, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.unified-inbox.settingsLink"
        })
      })
    })]
  });
};
InboxSettingsFooterSection.displayName = 'InboxSettingsFooterSection';
export default InboxSettingsFooterSection;